import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import SignatureCanvas from 'react-signature-canvas';
import '../css/Prestamos.css';

const Prestamos = () => {
  const [choferes, setChoferes] = useState([]);
  const [chofer, setChofer] = useState('');
  const [cantidad, setCantidad] = useState('');
  const [descripcion, setDescripcion] = useState('');
  const [mensaje, setMensaje] = useState('');
  const sigCanvas = useRef();

  useEffect(() => {
    const fetchChoferes = async () => {
      try {
        const res = await axios.get('https://deudas.transpoortessolorzano.com/choferes');
        setChoferes(res.data);
      } catch (error) {
        console.error('Error al cargar choferes:', error);
      }
    };
    fetchChoferes();
  }, []);

  const handlePrestamoSubmit = async (e) => {
    e.preventDefault();

    if (!chofer || !cantidad || parseFloat(cantidad) <= 0 || sigCanvas.current.isEmpty()) {
      setMensaje('Completa todos los campos y asegúrate de firmar.');
      return;
    }

    const firmaBase64 = sigCanvas.current.getCanvas().toDataURL('image/png');

    try {
      await axios.post('https://deudas.transpoortessolorzano.com/prestamos', {
        chofer_id: chofer,
        cantidad,
        descripcion,
        firma: firmaBase64,
      });

      setMensaje('Préstamo guardado correctamente.');
      setChofer('');
      setCantidad('');
      setDescripcion('');
      sigCanvas.current.clear();
    } catch (error) {
      console.error('Error al guardar el préstamo:', error);
      setMensaje('Ocurrió un error al guardar el préstamo.');
    }
  };

  return (
    <div className="prestamos-container">
      <h2 className="prestamos-title">Registro de Préstamos</h2>
      {mensaje && <p className="prestamos-message">{mensaje}</p>}
      <form className="prestamos-form" onSubmit={handlePrestamoSubmit}>
        <label className="prestamos-label">Chofer:</label>
        <select
          className="prestamos-select"
          value={chofer}
          onChange={(e) => setChofer(e.target.value)}
        >
          <option value="">Selecciona un chofer</option>
          {choferes.map((c) => (
            <option key={c.id} value={c.id}>
              {c.nombre}
            </option>
          ))}
        </select>

        <label className="prestamos-label">Cantidad:</label>
        <input
          className="prestamos-input"
          type="number"
          value={cantidad}
          onChange={(e) => setCantidad(e.target.value)}
        />

        <label className="prestamos-label">Motivo:</label>
        <textarea
          className="prestamos-textarea"
          value={descripcion}
          onChange={(e) => setDescripcion(e.target.value)}
        />

        <label className="prestamos-label">Firma:</label>
        <div className="prestamos-signature-box">
          <SignatureCanvas
            penColor="black"
            ref={sigCanvas}
            canvasProps={{
              width: 500,
              height: 180,
              className: 'signature-canvas',
            }}
          />
        </div>

        <button
          className="prestamos-button"
          type="button"
          onClick={() => sigCanvas.current.clear()}
        >
          Limpiar firma
        </button>

        <br />

        <button className="prestamos-button" type="submit">
          Guardar préstamo
        </button>
      </form>
    </div>
  );
};

export default Prestamos;
